import AboutMe from "../components/AboutMe";
import SideList from "../components/sections/SideList";
import Title from "../components/sections/Title";
import {professions, professionsTitle, certificates, certificatesTitle} from "../content/Introduction";

function Introduction(){
    return (
        <main className="flex-grow-1">
            <Title title="Bemutatkozás"/>
            <AboutMe/>
            <SideList title={professionsTitle} listItems={professions} id="professions"/>
            <SideList title={certificatesTitle} listItems={certificates} id="certificates" alignRight={true}/>
        </main>
    );
}

export default Introduction;